const filterSectionNameMap = {
  status: 'FilterDevice',
  wdacDeviceStatus: 'FilterDevice',
  healthStatus: 'FilterDevice',
  osVersion: 'FilterDevice',
  osSku: 'FilterDevice',
  osType: 'FilterDevice',
  TagName: 'FilterDevice',
  CustomerEnvTagId: 'Filter',
  PackagedAppStatuses: 'Filter',
  Tags: 'Filter',
  IsSigned: 'Filter',
  SignatureKind: 'Filter',
  GlobalAppStatus: 'Filter',
  lastContactDate: 'FilterDevice',
  logCollectorVersionSelect: 'FilterDevice',
  logTypes: 'LogFilesFilter',
  processName: 'FilterWdac',
  CustomerEnvAppIds: 'Filter',
  FilterDeviceManagedInstallerRuleStatuses: 'Filter',
};

const sourceValueMap = {
  wdac_import: 'WdacImport',
  installation_import: 'InstallationImport',
};

export const parseQueryToApiQuery = ({
  filters,
  page,
  limit,
  searchValue,
  omitSortFieldName = false,
  omitSortOrderName = false,
  ...rest
}) => {
  const queryParts = [];
  if (!!filters && Object.keys(filters).length > 0) {
    for (const [filterSectionName, filterSectionData] of Object.entries(filters)) {
      let filterSectionQueryData = {};
      let source = '';
      filterSectionData.forEach(section => {
        const [primarySection, secondarySection] = section.filter(
          sectionItem =>
            'value' in sectionItem && sectionItem.value !== null && sectionItem.value !== undefined,
        );
        if (primarySection && secondarySection) {
          if (filterSectionQueryData[primarySection.value]) {
            filterSectionQueryData[primarySection.value].push(secondarySection.value);
          } else {
            filterSectionQueryData[primarySection.value] = [secondarySection.value];
          }
        }
        if (primarySection && !secondarySection && primarySection?.name) {
          filterSectionQueryData[primarySection?.name] = [primarySection?.value];
        }
        if (section[0].order && !filterSectionQueryData.order) {
          filterSectionQueryData.order = section[0].order;
        }

        if (!source) {
          source = section.reduce((acc, sectionPart) => sectionPart?.source, '');
        }
      });

      Object.entries(filterSectionQueryData).forEach(([key, value]) => {
        if (filterSectionName === 'source' && key === 'source') {
          if (Array.isArray(value) && value.length > 0) {
            // this is used in apps filtering for SourceFilter
            value.forEach(sourceValue => {
              if (sourceValue && typeof sourceValue === 'string' && sourceValue.trim() !== '') {
                const mappedValue = sourceValueMap[sourceValue] || sourceValue;
                if (mappedValue && typeof mappedValue === 'string' && mappedValue.trim() !== '') {
                  queryParts.push(`SourceFilter=${mappedValue}`);
                }
              }
            });
          }
          return;
        }

        const mappedFilerSectionName = filterSectionNameMap[filterSectionName] || filterSectionName;
        if (
          Array.isArray(value) &&
          value.length > 0 &&
          typeof value[0] === 'string' &&
          value[0].trim() !== ''
        ) {
          queryParts.push(
            `${source ? `${source}.` : ''}${mappedFilerSectionName}.${key}=${value.join(',')}`,
          );
        } else if (key === 'order') {
          const filterSectionQueryDataItem = filterSectionData
            .flat()
            .find(filterSectionDataItem => filterSectionDataItem.order);

          queryParts.push(
            omitSortFieldName
              ? `sortBy=${filterSectionQueryDataItem?.sortingCellField || filterSectionName}`
              : `${filterSectionQueryDataItem?.sortFieldName || 'orderQuery'}.sortBy=${
                  filterSectionQueryDataItem?.sortingCellField || filterSectionName
                }`,
          );
          queryParts.push(
            omitSortOrderName
              ? `order=${filterSectionQueryDataItem?.order || value}`
              : `${filterSectionQueryDataItem?.sortFieldName || 'orderQuery'}.order=${value}`,
          );
        } else {
          if (
            Array.isArray(value) &&
            value.length > 0 &&
            typeof value[0] === 'string' &&
            value[0].trim() === ''
          )
            return;
          queryParts.push(`${mappedFilerSectionName}.${key}=${value}`);
        }
      });
    }
  }
  // Todo: change this condition check
  if (
    searchValue !== 'undefined' &&
    searchValue !== '' &&
    searchValue !== null &&
    searchValue !== undefined
  ) {
    queryParts.push(`search=${encodeURIComponent(searchValue)}`);
  }

  if (rest) {
    Object.entries(rest).forEach(([key, value]) => {
      const parseValue = key.toLowerCase().includes('filters') ? JSON.stringify(value) : value;
      queryParts.push(`${key}=${parseValue}`);
    });
  }

  if (!queryParts.length) return '';

  const queryString = queryParts.join('&');

  return `?${limit ? `Limit=${limit}` : ''}${page ? `&Page=${page}` : ''}&${queryString}`;
};
